import { createFileRoute } from "@tanstack/react-router"
import { TermsPage } from "./-TermsPage"

export const Route = createFileRoute("/terms")({
  component: TermsPage,
})
